export class NoGenresFoundError extends Error {}

export const isNoGenresFoundError = (e: unknown) =>
  e instanceof NoGenresFoundError;
